var exports = {
  "modalBackdrop": "Modal.module__modalBackdrop___Smwtd1",
  "layer": "Modal.module__layer___Smwtd1",
  "backdropSlot": "Modal.module__backdropSlot___Smwtd1",
  "positionAbsoluteInsetZero": "Modal.module__positionAbsoluteInsetZero___Smwtd1",
  "backdropCentered": "Modal.module__backdropCentered___Smwtd1",
  "focusLock": "Modal.module__focusLock___Smwtd1",
  "surface": "Modal.module__surface___Smwtd1",
  "layerFullscreen": "Modal.module__layerFullscreen___Smwtd1",
  "layerFullscreenMobile": "Modal.module__layerFullscreenMobile___Smwtd1",
  "layerCentered": "Modal.module__layerCentered___Smwtd1",
  "root": "Modal.module__root___Smwtd1",
  "centeredOnMobile": "Modal.module__centeredOnMobile___Smwtd1",
  "rootAnimating": "Modal.module__rootAnimating___Smwtd1",
  "medium": "Modal.module__medium___Smwtd1",
  "small": "Modal.module__small___Smwtd1",
  "large": "Modal.module__large___Smwtd1",
  "xlarge": "Modal.module__xlarge___Smwtd1",
  "fullscreen": "Modal.module__fullscreen___Smwtd1",
  "layout": "Modal.module__layout___Smwtd1",
  "header": "Modal.module__header___Smwtd1",
  "light": "Modal.module__light___Smwtd1",
  "dark": "Modal.module__dark___Smwtd1",
  "footer": "Modal.module__footer___Smwtd1",
  "stretchButtons": "Modal.module__stretchButtons___Smwtd1",
  "headerInner": "Modal.module__headerInner___Smwtd1",
  "headerText": "Modal.module__headerText___Smwtd1",
  "content": "Modal.module__content___Smwtd1",
  "contentNoPadding": "Modal.module__contentNoPadding___Smwtd1",
  "screenReaderLabel": "Modal.module__screenReaderLabel___Smwtd1",
  "insetCloseButtonContainer": "Modal.module__insetCloseButtonContainer___Smwtd1",
  "insetCloseButton": "Modal.module__insetCloseButton___Smwtd1",
  "contentLayout": "Modal.module__contentLayout___Smwtd1",
  "description": "Modal.module__description___Smwtd1",
  "inputGroup": "Modal.module__inputGroup___Smwtd1",
  "formFooter": "Modal.module__formFooter___Smwtd1",
};

__webpack_require__.r(module.exports = exports);
